<template>

  <v-card color="white" class="card-border">
    <v-system-bar height="45" window color="itoviGrayLight">
      <h2 class="card-header-text">Your Plan</h2>
      <v-spacer></v-spacer>
    </v-system-bar>

    <ManagePlanDialog v-if="!!plan_details" v-model="showManagePlanDialog" :plan="plan_details" ></ManagePlanDialog>
    <ManageAddOnsDialog v-if="!!add_ons" v-model="showManageAddOnsDialog" :add-ons="add_ons" ></ManageAddOnsDialog>
    <ViewPlanDetailsDialog v-if="!!plan_details" v-model="showPlanDetailsDialog" :plan="plan_details" ></ViewPlanDetailsDialog>

    <div v-if="!(!!plan_details && !!next_payment_info && !!add_ons)" class="pa-4">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </div>
    <div class="card-body" v-if="!!plan_details && !!next_payment_info && !!add_ons">

      <!-- Plan name               -->
      <v-layout align-center row wrap>
        <v-flex xs7>
          <v-layout column class="ma-0">
            <span class="txt-bold">{{ plan_details.name }}</span>
            <div v-if="plan_details.monthly !== null && plan_details.monthly > 0">
              ${{ plan_details.monthly }} / mo
            </div>
            <span v-if="plan_details.status === 'paused'">(Paused)</span>
            <span v-if="plan_details.status === 'cancelled'">(Cancelled)</span>
          </v-layout>
        </v-flex>
        <v-flex xs5>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn small flat color="accent"
                   v-if="plan_details.upgradeable_plans.length > 0"
                   @click="showManagePlanDialog=true" class="txt-bold">Manage
            </v-btn>
            <v-btn small flat color="accent"
                   v-if="plan_details.upgradeable_plans === false || plan_details.upgradeable_plans.length === 0"
                   @click="showPlanDetailsDialog=true" class="txt-bold">View
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout v-if="plan_details.pending_status" align-center row wrap>
        <div>
          This plan is scheduled to be {{ plan_details.pending_status.action_code === 'cancel' ? 'cancelled' : (plan_details.pending_status.action_code === 'hold' ? 'placed on hold' : 'changed') }} on {{ plan_details.pending_status.run_date }}.
        </div>
      </v-layout>


      <v-divider class="mt-4 mb-3"></v-divider>

      <!-- Add-ons               -->
      <v-layout align-center row wrap class="pb-2">
        <span class="txt-bold">Add-ons &<br/>Premium Content</span>
        <v-spacer></v-spacer>
        <v-btn small flat color="accent" class="txt-bold"
               @click="showManageAddOnsDialog=true">Manage
        </v-btn>
      </v-layout>

      <template v-for="(item, index) in add_ons.applied">
        <v-layout :key="index" align-center row wrap>
          <span>{{ item.name }}</span>
          <v-spacer></v-spacer>
          <span v-if="item.is_yearly > 0" class="pr-3">${{ item.yearly }} / year</span>
          <span v-if="!item.is_yearly > 0 && item.monthly > 0" class="pr-3">${{ item.monthly }} / mo</span>
        </v-layout>
      </template>

      <v-divider class="mt-4 mb-3"></v-divider>

      <!-- Monthly payment               -->
      <v-layout align-center row wrap>
        <span class="txt-bold">Monthly Payment</span>
        <v-spacer></v-spacer>
        <span class="txt-bold">${{ next_payment_info.amount }}</span>
        <span class="txt-bold"
              style="font-size: 7pt;">&nbsp;/ mo</span>
      </v-layout>

    </div>
  </v-card>

</template>

<script>
  import api from "../../../services/api_endpoints";
  import store from '../../../store'
  import ManagePlanDialog from './ManagePlanDialog'
  import ManageAddOnsDialog from './ManageAddOnsDialog'
  import ViewPlanDetailsDialog from './ViewPlanDetailsDialog'

  export default {
    components: {
      ManagePlanDialog,
      ViewPlanDetailsDialog,
      ManageAddOnsDialog,
    },
    data: ()=> ({
      plan_details: store.state.planDetails,
      next_payment_info: store.state.nextPayment,
      add_ons: store.state.addOns,
      showManagePlanDialog: false,
      showManageAddOnsDialog: false,
      showPlanDetailsDialog: false,
    }),
    props: {
      onLoaded: Function,
    },
    created(){
      this.fetchData();
      if (this.$route.query.hasOwnProperty('addons')) {
        this.showManageAddOnsDialog = true;
      }
    },
    mounted() {
      // subscribe to changes on the state
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setNextPayment') {
          // console.log(`Updating setNextPayment - ${state}`);
          this.next_payment_info = state.nextPayment
        } else if (mutation.type === 'setAddOns') {
          // console.log(`Updating setAddOns - ${state}`);
          this.add_ons = state.addOns
        } else if (mutation.type === 'setPlanDetails') {
          // console.log(`Updating setPlanDetails - ${state}`);
          this.plan_details = state.planDetails
        }
      })
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchData() {
        this.plan_details = await api.getPlanDetails()
        this.add_ons = await api.getPlanAddOns()
        this.next_payment_info = await api.getNextPayment()
        if (this.isFunction(this.onLoaded)) this.onLoaded()
      },
    },
  }
</script>
